import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { SellModalProps } from "../../interfaces/containers";
import SellModal from "../../components/SellModal";
import { 
    getBrands, 
    cleanGetBrands, 
    setBrand, 
    getModels, 
    cleanGetModels, 
    setModel, 
    getVersions, 
    getYears, 
    cleanGetYears, 
    getSuggestedPrice, 
    setRecord, 
    setKms,
    setFuel,
    setTransmission,
    setType,
    setColor,
    setDoors,
    setVersion,
    setYear,
    getAdditionalCharacters,
    setAdditionalCharacters,
    setSelectedAdditionalCharacters,
    getRegions,
    setRegion
} from "../../actions/salePost";
function mapStateToProps(state: SellModalProps) {
    return{
        kms: state.salePost.kms,
        color: state.salePost.color,
        fuel: state.salePost.fuel,
        version: state.salePost.version,
        versions: state.salePost.versions,
        fetchingVersions: state.salePost.fetchingVersions,
        models: state.salePost.models,
        year: state.salePost.years.selected,
        plate: state.salePost.plate,
        isFoundPlate: state.salePost.isFoundPlate,
        vehicleType: state.salePost.vehicle_type,
        transmission: state.salePost.transmission,
        doors: state.salePost.doors,
        brands: state.salePost.brands,
        years: state.salePost.years,
        request_id: state.salePost.request_id,
        vehicleData: state.salePost.vehicleData,
        accidentsReported: state.salePost.record.accidentsReported,
        personalUse: state.salePost.record.personalUse,
        soleOwner: state.salePost.record.soleOwner,
        additionalCharacters: state.salePost.additional_characters,
        selectedAdditionalCharacters: state.salePost.selectedAdditionalCharacters,
        region: state.salePost.region,
        regions : state.salePost.regions

    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getBrands, 
        cleanGetBrands, 
        setBrand, 
        getModels, 
        cleanGetModels, 
        setModel, 
        getVersions, 
        getYears, 
        cleanGetYears, 
        getSuggestedPrice, 
        setRecord,
        setKms,
        setFuel,
        setTransmission,
        setType,
        setColor,
        setDoors,
        setVersion,
        setYear,
        getAdditionalCharacters,
        setAdditionalCharacters,
        setSelectedAdditionalCharacters,
        getRegions,
        setRegion
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(SellModal);